import { render, staticRenderFns } from "./PrefectureModal.vue?vue&type=template&id=58fc6cef&"
import script from "./PrefectureModal.vue?vue&type=script&lang=js&"
export * from "./PrefectureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports